var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiLgSummary = function SvgAiLgSummary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 61 30"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 19,
    x: 26,
    y: 1,
    fill: "#A8FFF8",
    rx: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 10,
    x: 16,
    y: 16,
    fill: "#CBFF88",
    rx: 1,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillRule: "evenodd",
    d: "M24.304 4.38c0-.21.185-.38.413-.38h14.87c.228 0 .413.17.413.38v15.2c0 .21-.185.38-.413.38h-14.87c-.228 0-.413-.17-.413-.38zm.826.38V19.2h14.044V4.76z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillRule: "evenodd",
    d: "M21.413 6.28c.228 0 .413.17.413.38v15.58H37.11c.228 0 .413.17.413.38s-.185.38-.413.38H21.413c-.228 0-.413-.17-.413-.38V6.66c0-.21.185-.38.413-.38",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    d: "M33.804 7.8c.228 0 .413.17.413.38s-.184.38-.413.38h-6.608c-.229 0-.413-.17-.413-.38s.184-.38.413-.38zM37.109 11.6c.228 0 .413.17.413.38s-.185.38-.413.38h-9.913c-.229 0-.413-.17-.413-.38s.184-.38.413-.38zM37.109 15.4c.228 0 .413.17.413.38s-.185.38-.413.38h-9.913c-.229 0-.413-.17-.413-.38s.184-.38.413-.38z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#14454C",
    fillOpacity: 0.15,
    d: "M23 13h17v11H23z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#14D1C2",
    d: "m50.5 6 .99 2.51L54 9.5l-2.51.99L50.5 13l-.99-2.51L47 9.5l2.51-.99zM59 17l.566 1.434L61 19l-1.434.566L59 21l-.566-1.434L57 19l1.434-.566zM9.5 21l.99 2.51 2.51.99-2.51.99L9.5 28l-.99-2.51L6 24.5l2.51-.99zM2 16l.566 1.434L4 18l-1.434.566L2 20l-.566-1.434L0 18l1.434-.566z"
  })));
};
export { SvgAiLgSummary as ReactComponent };
export default __webpack_public_path__ + "fonts/ai-lg-summary-f11d85c8adc35773dd4430e275f03fee.svg";